import { h } from "preact";
import { useState, useEffect } from "preact/hooks";

import classname from "../../foundation/utils/classname";
import { copyContent } from "../../foundation/utils/platform";

import "./style.css";

interface Props {
    copyActionText: string;
    copyDoneText: string;
    lines: string[];
}

function CopyContents({ copyActionText, copyDoneText, lines }: Props) {
    const [copied, setCopied] = useState(false);

    useEffect(() => {
        setCopied(false);
    }, [JSON.stringify(lines)]);

    function handleCopy() {
        copyContent({
            content: lines.join("\n")
        });

        setCopied(true);
    }

    return (
        <button onClick={handleCopy} class={classname("copyContents", { copied })}>
            <p>{copied ? copyDoneText : copyActionText}</p>
            <strong>
                {lines.map((line, index) => <span key={index}>{line}</span>)}
            </strong>
        </button>
    );
}

export default CopyContents;
